import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Title from "../../../../utils/title/Title";

const WorkDeviceChart = ({ data }) => {
  const deviceTypes = [
    "Desktop Computer",
    "Laptop",
    "Smart Phone",
    "Tablet",
    "No Device",
  ];

  const processCountryData = (country) => {
    const filtered = data.filter((d) =>
      country === "Ghana"
        ? d.country?.includes("Ghana")
        : !d.country || d.country.includes("Ibadan")
    );
    const total = filtered.length;

    const countryData = { country, total };

    deviceTypes.forEach((device) => {
      const count = filtered.filter((d) => d.currentDeviceUsed.includes(device))
        .length;
      const percentage = total > 0 ? ((count / total) * 100).toFixed(1) : 0;
      countryData[device] = count;
      countryData[`${device}_percentage`] = `${count} (${percentage}%)`;
    });

    return countryData;
  };

  const processedData = ["Ibadan", "Ghana"].map(processCountryData);

  return (
    <>
      <Title
        text="Comparative Analysis of Applicants' Work Devices in Ibadan & Ghana"
        textAlign="center"
        style={{
          marginBottom: "1rem",
          fontSize: "2rem",
        }}
      />
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={processedData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="country" />
          <YAxis />
          <Tooltip
            formatter={(value, name, props) => {
              const countryData = processedData.find(
                (d) => d.country === props.payload.country
              );
              return [`${value} (${countryData[`${name}_percentage`]})`, name];
            }}
          />
          <Legend
            formatter={(value) => (
              <span>
                {value} (Ibadan: {processedData[0][`${value}_percentage`]}) | (Ghana: {processedData[1][`${value}_percentage`]})
              </span>
            )}
          />
          {deviceTypes.map((device, index) => (
            <Bar
              key={device}
              dataKey={device}
              fill={["#eb8145", "#89B369", "#8dd1e1", "#727272", "#FF5151"][index]}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default WorkDeviceChart;
